import { render, staticRenderFns } from "./printCredentialsDeposit.vue?vue&type=template&id=1def6dc4&scoped=true&"
import script from "./printCredentialsDeposit.vue?vue&type=script&lang=js&"
export * from "./printCredentialsDeposit.vue?vue&type=script&lang=js&"
import style0 from "./printCredentialsDeposit.vue?vue&type=style&index=0&id=1def6dc4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1def6dc4",
  null
  
)

export default component.exports